import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import { Button } from 'react-bootstrap';
const uuid = require('uuid');
const moment = require('moment-timezone');
import { Row } from 'react-bootstrap';
import {H, Section } from "react-headings";
const _ = {
    find: require('lodash/find'),
    forEach: require('lodash/forEach'),
};

const Strings = require('../../../../app/shared/Strings');
const AnalyticsActions = require('../../actions/AnalyticsActions');
const AnalyticsStore = require('../../stores/AnalyticsStore');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const FeatureUtil = require('../../../../app/shared/FeatureUtil');
const VersionUtil = require('../../util/version');
import Navigator from '../../Navigator';
import WithChannelData from '../DataHOCs/WithChannelData';
import WithProjectData from '../DataHOCs/WithProjectData';
import WithActivityData from '../DataHOCs/WithActivityData';
import MainNav from '../DashboardNew/Menu/MainNav';
import SubNav from '../nav/SubNav';
import BackButton from '../nav/BackButton';
import { ActivityBreadCrumbs } from '../nav/NavBreadCrumbs';
import Tooltip from '../common/Tooltip';
import VersionRangeSelector from './qla/VersionRangeSelector';
import QLAVersionLog from './qla/QLAVersionLog';
import QLAUsageCharts from './qla/QLAUsageCharts';
import QLALOCharts from './qla/QLALOCharts';
import QLAQuestionSummaryTable from './qla/QLAQuestionSummaryTable';

const propTypes = {
    history: PropTypes.object.isRequired,
    activityId: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    channelId: PropTypes.string.isRequired,
    channelStoreState: PropTypes.shape({
        channel: PropTypes.object.isRequired,
        foldersFlat: PropTypes.object.isRequired,
    }).isRequired,
    projectStoreState: PropTypes.shape({
        project: PropTypes.object.isRequired
    }).isRequired,
	activityStoreState: PropTypes.shape({
		activity: PropTypes.object.isRequired
	}).isRequired,
};
const defaultProps = {};

class ActivityQLAView extends React.Component {
	constructor(props) {
		super(props);
        this._getFirstLatestMajor = this._getFirstLatestMajor.bind(this);
        this._getFullRangeForVersion = this._getFullRangeForVersion.bind(this);
		const analyticsStoreState = AnalyticsStore.getState();
		const versionsInit = !!analyticsStoreState.activityQlaVersions[props.activityId];
        const versions = versionsInit ? analyticsStoreState.activityQlaVersions[props.activityId].versions : {};
        const rangesForVersions = versionsInit ? analyticsStoreState.activityQlaVersions[props.activityId].ranges_for_versions : {};
        const selectedMinVersion = versionsInit ? this._getFirstLatestMajor(versions) : undefined;
        const selectedMaxVersion = versionsInit ? this._getFullRangeForVersion(selectedMinVersion, rangesForVersions) : undefined;
		this.state = {
			getActivityVersionsActionId: null,
            getActivityQlaUsageActionId: null,
            getActivityLoUsageActionId: null,
            getActivityQlaQuestionSummaryActionId: null,
            getActivityQlaQuestionDetailsActionId: null,
            versionsInit: versionsInit,
            versionRanges: rangesForVersions,
            versions: versions,
            selectedMinVersion: selectedMinVersion,
            selectedMaxVersion: selectedMaxVersion,
            activeMinVersion: null,
            activeMaxVersion: null,
            activityUsage: null,
            loUsage: null,
            overallChartType: 'donut',
            loChartType: 'donut',
            questionSummary: null,
            questionDetails: null
		};

		this.backHandler = this.backHandler.bind(this);
		this.checkInitDataLoaded = this.checkInitDataLoaded.bind(this);
		this.checkPermissions = this.checkPermissions.bind(this);
		this.checkToGetActQlaVersions = this.checkToGetActQlaVersions.bind(this);
		this.onChangeMinVersion = this.onChangeMinVersion.bind(this);
		this.onChangeMaxVersion = this.onChangeMaxVersion.bind(this);
        this.canUpdate = this.canUpdate.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
        this.onChangeOverallChartType = this.onChangeOverallChartType.bind(this);
        this.onChangeLoChartType = this.onChangeLoChartType.bind(this);
        this.onRequestQuestionDetails = this.onRequestQuestionDetails.bind(this);
		this.unsubscribes = [
			AnalyticsStore.listen(this.onAnalyticsStoreChage.bind(this))
		];
	}

    UNSAFE_componentWillMount() {
    	this.checkToGetActQlaVersions();
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onAnalyticsStoreChage(state) {
        let newState = {};
        if (state.action.id === this.state.getActivityVersionsActionId) {
            newState = { ...newState, getActivityVersionsActionId: null };
            if (!state.action.error) {
            	newState = {
            		...newState,
					versionRanges: state.activityQlaVersions[this.props.activityId].ranges_for_versions,
					versions: state.activityQlaVersions[this.props.activityId].versions,
                    versionsInit: true,
            	};
            	const verArr = Object.keys(state.activityQlaVersions[this.props.activityId].versions);
            	if (verArr.length > 0) {
                    const selectedMinVersion = this._getFirstLatestMajor(state.activityQlaVersions[this.props.activityId].versions);
                    const selectedMaxVersion = this._getFullRangeForVersion(selectedMinVersion, state.activityQlaVersions[this.props.activityId].ranges_for_versions);
            		newState.selectedMinVersion = selectedMinVersion;
            		newState.selectedMaxVersion = selectedMaxVersion;
            	}

            }
            
        }

        if (state.action.id === this.state.getActivityQlaUsageActionId)  {
            newState = { ...newState, getActivityQlaUsageActionId: null };   
            if (!state.action.error) {
                const minV = state.activityQlaUsage[this.props.activityId].minVersion;
                const maxV = state.activityQlaUsage[this.props.activityId].maxVersion;
                const { maxVersion, minVersion, ...data } = state.activityQlaUsage[this.props.activityId];
                newState = {
                    ...newState,
                    activeMinVersion: minV,
                    activeMaxVersion: maxV,
                    activityUsage: data,
                };
            }
        }


        if (state.action.id === this.state.getActivityLoUsageActionId)  {
            newState = { ...newState, getActivityLoUsageActionId: null };   
            if (!state.action.error) {
                newState = {
                    ...newState,
                    loUsage: state.activityQlaLoUsage[this.props.activityId],
                };
            }
        }

        if (state.action.id === this.state.getActivityQlaQuestionSummaryActionId) {
            newState = { ...newState, getActivityQlaQuestionSummaryActionId: null };   
            if (!state.action.error) {
                newState = {
                    ...newState,
                    activeMinVersion: state.activityQlaQuestionSummary[this.props.activityId].minVersion,
                    activeMaxVersion: state.activityQlaQuestionSummary[this.props.activityId].maxVersion,
                    questionSummary: state.activityQlaQuestionSummary[this.props.activityId].questionSummary,
                };
            }
        }

        if (state.action.id === this.state.getActivityQlaQuestionDetailsActionId) {
            newState = { ...newState, getActivityQlaQuestionDetailsActionId: null };
            if (!state.action.error) {
                var questionDetails = this.filterQuestionDetails(state.activityQlaQuestionDetails[this.props.activityId],true);
                newState = {
                    ...newState,
                    questionDetails,
                };
            }
        }


        this.setState(newState);
    }

    backHandler() {
        Navigator.goToActivityView(this.props.history, this.props.channelId, this.props.projectId, this.props.activityId);
    }

    checkInitDataLoaded() {
    	if (
    		!this.props.channelStoreState.channel
    		|| !this.props.projectStoreState.project
    		|| !this.props.activityStoreState.activity
    	) {
    		return false;
    	}
    	else {
    		return true;
    	}
    }

    checkPermissions() {
        if (!this.checkInitDataLoaded()) {
        	console.warn('No channel, project, or activity');
        	return false;
        }

        // account does not have detailed analytics
	    if (!FeatureUtil.hasDetailedAnalytics(this.props.channelStoreState.channel.channel_permissions)) {
	        console.warn('Account does not have Detailed Analytics feature');
	        return false;
	    }

        // user does not have project/channel permissions to view analytics
        if (!PermissionsUtil.viewDetailedProjectAnalytics(this.props.channelStoreState.channel.user_permissions, this.props.projectStoreState.project.user_permissions)) {
        	console.warn('User does not have View Analytics permission');
            return false;
        }

        return true;
    }

    _getFirstLatestMajor(verObj) {
        let matchingVersion;
        Object.keys(verObj).forEach((version) => {
            const parsedVer = VersionUtil.parseVersion(version);
            if (
                !matchingVersion
                || parsedVer.major > matchingVersion.major
                || parsedVer.compare(matchingVersion) < 0
            ) {
                matchingVersion = parsedVer;
            }
        });

        return !!matchingVersion ? matchingVersion.toString() : undefined;
    }

    _getFullRangeForVersion(version, verRangeObj) {
        const range = verRangeObj[version];
        if (!range || range.length === 0) {
            console.warn(`getFullRangeForVersion no range in verRangeObj for ${version}`);
        }

        return range[range.length - 1];
    }

    checkToGetActQlaVersions(channelStoreState, projectStoreState) {
    	if (!this.checkPermissions()) {
    		this.backHandler();
    		return;
    	}

        if (!this.state.versionsInit) {
            const getActivityVersionsActionId = uuid.v4();
            this.setState({ getActivityVersionsActionId: getActivityVersionsActionId }, () => {
                AnalyticsActions.getActivityQlaVersions(
                	getActivityVersionsActionId,
                	{
                		channelId: this.props.channelId,
                		activityId: this.props.activityId,
                	}
                );

            });
        }
    }

	onChangeMinVersion(e) {
		const version = e.target.value;
		if (version === this.state.selectedMinVersion) return;

		this.setState({
			selectedMinVersion: version,
			selectedMaxVersion: this._getFullRangeForVersion(version, this.state.versionRanges),
		});
	}

	onChangeMaxVersion(e) {
		const version = e.target.value;
		if (version === this.state.selectedMaxVersion) return;

		this.setState({ selectedMaxVersion: version });
	}

    canUpdate() {
        return (
            !this.state.getActivityQlaUsageActionId
            && !this.state.getActivityQlaQuestionSummaryActionId
            && (
                this.state.activeMinVersion !== this.state.selectedMinVersion
                || this.state.activeMaxVersion !== this.state.selectedMaxVersion
            )
        );
    }
    
    // filter questionDetails to only those that match the current version range
    filterQuestionDetails=(questionDetails,forceChange)=>{
        var anyDetailsExcluded = false;
        var newDetails = {};
        _.forEach(questionDetails,(qd,questionId)=>{
            if ((qd.minVersion === this.state.selectedMinVersion) && (qd.maxVersion === this.state.selectedMaxVersion)) {
                newDetails[questionId] = qd;
            }
            else {
                anyDetailsExcluded = true;
            }
        });
        if (anyDetailsExcluded || forceChange) {
            return newDetails;
        }
        return questionDetails; // no filtering needed
    }

	onUpdate() {
        const getActivityQlaUsageActionId = uuid.v4();
        const getActivityQlaQuestionSummaryActionId = uuid.v4();
        const getActivityLoUsageActionId = uuid.v4();
        
        var questionDetails = this.filterQuestionDetails(this.state.questionDetails);
        this.setState({
            getActivityQlaUsageActionId,
            getActivityLoUsageActionId,
            getActivityQlaQuestionSummaryActionId,
            questionDetails
        }, () => {
            AnalyticsActions.getActivityQlaUsage(
                getActivityQlaUsageActionId,
                {
                    channelId: this.props.channelId,
                    activityId: this.props.activityId,
                    minVersion: this.state.selectedMinVersion,
                    maxVersion: this.state.selectedMaxVersion,
                }
            );

            AnalyticsActions.getActivityQlaLoUsage(
                getActivityLoUsageActionId,
                {
                    channelId: this.props.channelId,
                    activityId: this.props.activityId,
                    minVersion: this.state.selectedMinVersion,
                    maxVersion: this.state.selectedMaxVersion,
                }
            );

            AnalyticsActions.getActivityQlaQuestionSummary(
                getActivityQlaQuestionSummaryActionId,
                {
                    channelId: this.props.channelId,
                    activityId: this.props.activityId,
                    minVersion: this.state.selectedMinVersion,
                    maxVersion: this.state.selectedMaxVersion,
                }
            );
        });
		
	}

    // returns true if we can request the specified details
    // returns false if we can't (because there's already a request in progress)
    onRequestQuestionDetails(question_id, question_type, successCallback=null, failureCallback=null) {
		console.log(`onRequestQuestionDetails(${question_id}, ${question_type})`);
        var qd = this.state.questionDetails && this.state.questionDetails[question_id];
        if (qd) {
            // see if it's the correct version
            if ((qd.minVersion === this.state.selectedMinVersion) && (qd.maxVersion === this.state.selectedMaxVersion)) {
                // we have the details (request GRANTED)
                if (successCallback) successCallback();
                return;
            }
        }

        if (this.state.getActivityQlaQuestionDetailsActionId) {
            // we are already waiting for details (request DENIED)
            if (failureCallback) failureCallback();
            return;
        }

        const getActivityQlaQuestionDetailsActionId = uuid.v4();
        this.setState({ getActivityQlaQuestionDetailsActionId },()=>{
            AnalyticsActions.getActivityQlaQuestionDetails(
                getActivityQlaQuestionDetailsActionId,
                {
                    channelId: this.props.channelId,
                    activityId: this.props.activityId,
                    minVersion: this.state.selectedMinVersion,
                    maxVersion: this.state.selectedMaxVersion,
                    questionId: question_id,
                    questionType: question_type
                }
            ); 
            if (successCallback) successCallback();
        });
    }

    onChangeOverallChartType(e) {
        const chartType = e.target.value;
        if (
            (chartType === this.state.overallChartType)
            || (chartType !== 'donut' && chartType !== 'bar')
        ) {
            return;
        }

        this.setState({ overallChartType: chartType });
    }

    onChangeLoChartType(e) {
        const chartType = e.target.value;
        if (
            (chartType === this.state.loChartType)
            || (chartType !== 'donut' && chartType !== 'bar')
        ) {
            return;
        }

        this.setState({ loChartType: chartType });
    }

	render() {
		if (!this.checkInitDataLoaded()) {
			return null;
		}

        const DATE_FORMAT = 'YY-MM-DD HH:mm zz';
        const minVersion = !!this.state.activeMinVersion && !!this.state.versionsInit && this.state.versions[this.state.activeMinVersion] ? this.state.versions[this.state.activeMinVersion] : null;
        const maxVersion = !!this.state.activeMaxVersion && !!this.state.versionsInit && this.state.versions[this.state.activeMaxVersion] ? this.state.versions[this.state.activeMaxVersion] : null;
		return (
			<div>
                <MainNav
                    onClickBrandLogo={() => Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, this.props.channelId)}
                />
                <div className="container-fluid main-container">
                    <SubNav containerClassName="subnav__container-fluid">
                        <BackButton backHandler={this.backHandler} />
                        <div className="view-info-container">
                            <div className="view-title">
                                {Strings['en'].activity.qla.QLA_TITLE + ' - ' + this.props.activityStoreState.activity.meta_data.title}
                            </div>
                            <div className="view-description">
                                <ActivityBreadCrumbs
                                    channel={this.props.channelStoreState.channel}
                                    project={this.props.projectStoreState.project}
                                    activity={this.props.activityStoreState.activity}
                                    foldersFlat={this.props.channelStoreState.foldersFlat}
                                />
                            </div>
                        </div>
                    </SubNav>

                    <div className="qlaView">
                        <Row>
                            <div className="col-12 col-sm-6">
                              <Section component={
                                <H className="md-heading margin-bottom-lg">
                                    {Strings['en'].activity.qla.act_version.DISP_VER_RANGE}
                                </H>
                              }>
                                <div className="text-centered margin-bottom-lg">
                                    {(!!minVersion) &&
                                        <div>
                                            {minVersion.version} - {minVersion.published_by_first_name} {minVersion.published_by_last_name} - {moment.tz(minVersion.published_on, moment.tz.guess()).format(DATE_FORMAT)}
                                        </div>
                                    }
                                    {(!!minVersion && !!maxVersion) &&
                                        <div className="margin-top-sm margin-bottom-sm"> - </div>
                                    }
                                    {(!!maxVersion) &&
                                        <div>
                                            {maxVersion.version} - {maxVersion.published_by_first_name} {maxVersion.published_by_last_name} - {moment.tz(maxVersion.published_on, moment.tz.guess()).format(DATE_FORMAT)}
                                        </div>
                                    }
                                </div>
                                <div className="text-centered margin-bottom-lg">
            	                    <label htmlFor="qla-ver-range-select" className="margin-right-xl">
            	                    	{Strings['en'].activity.qla.act_version.CUS_VER_RANGE}:
            	                    </label>
            	                    <VersionRangeSelector
            	                    	id="qla-ver-range-select"
            	                    	selectedMinVersion={this.state.selectedMinVersion}
            							selectedMaxVersion={this.state.selectedMaxVersion}
            							onChangeMinVersion={this.onChangeMinVersion}
            							onChangeMaxVersion={this.onChangeMaxVersion}
            							versionRanges={this.state.versionRanges}
            						/>
                                </div>
                                <div className="text-centered">
                					<Button disabled={!this.canUpdate()} onClick={this.onUpdate}>
                                        {Strings['en'].common.UPDATE}
                                    </Button>
                                </div>
                              </Section>
        					</div>
                            <div className="col-12 col-sm-6">
                              <Section component={
                                <H className="md-heading margin-bottom-lg">
                                    {Strings['en'].activity.qla.act_version.CMP_VER_LOG}
                                    <Tooltip id="qlaVerTable-tt" className="margin-left-sm" placement="right">
                                        {Strings['en'].activity.qla.act_version.CMP_VER_LOG_TT}
                                    </Tooltip>
                                </H>
                              }>
                                <div>
                                    <QLAVersionLog
                                        versions={this.state.versionsInit ? Object.values(this.state.versions) : []}
                                        activeMinVersion={this.state.activeMinVersion}
                                        activeMaxVersion={this.state.activeMaxVersion}
                                    />
                                </div>
                              </Section>
                            </div>
                        </Row>
                        {(!!this.state.activityUsage) &&
                            <div className="margin-top-xl">
                              <Section component={
                                <H className="md-heading margin-bottom-lg">
                                    {Strings['en'].activity.qla.charts.OVR_ACT_STATS}
                                </H>
                              }>
                                <QLAUsageCharts
                                    className="text-centered"
                                    chartType={this.state.overallChartType}
                                    onChangeChartType={this.onChangeOverallChartType}
                                    {...this.state.activityUsage}
                                />
                              </Section>
                            </div>
                        }
                        {(!!this.state.loUsage && this.state.loUsage.length > 0) &&
                            <div className="margin-top-xl">
                              <Section component={
                                <H className="md-heading margin-bottom-lg">
                                    {Strings['en'].activity.qla.charts.LO_USAGE}
                                </H>
                              }>
                                <QLALOCharts
                                    className="text-centered"
                                    chartType={this.state.loChartType}
                                    onChangeChartType={this.onChangeLoChartType}
                                    loUsage={this.state.loUsage}
                                />
                              </Section>
                            </div>
                        }
                        {(!!this.state.questionSummary) &&
                            <div className="margin-top-xl">
                              <Section component={
                                <H className="md-heading margin-bottom-lg">
                                    {Strings['en'].activity.qla.questions.Q_R_DATA}
                                </H>
                              }>
                                {(this.state.questionSummary.length > 0) ?
                                    <QLAQuestionSummaryTable
                                        activeMinVersion={this.state.activeMinVersion}
                                        activeMaxVersion={this.state.activeMaxVersion}
                                        questionSummary={this.state.questionSummary}
                                        questionDetails={this.state.questionDetails}
                                        requestDetails={this.onRequestQuestionDetails}
                                    />
                                    :
                                    <p className="font-style-italic">
                                        {Strings['en'].activity.qla.questions.Q_R_NO_QUESTIONS}
                                    </p>
                                }
                              </Section>
                            </div>
                        }
                    </div>
                </div>
			</div>
		);
	}
}

ActivityQLAView.propTypes = propTypes;
ActivityQLAView.defaultProps = defaultProps;


const WrappedComponent = withRouter(WithChannelData(WithProjectData(WithActivityData(ActivityQLAView))));

function WrappedComponentWithUpdatedPropNames(props) {
    return (
        <WrappedComponent
            {...props}
            activityId={props.match.params.activityId}
            projectId={props.match.params.projectId}
            channelId={props.match.params.channelId}
        />
    );
}

WrappedComponentWithUpdatedPropNames.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            channelId: PropTypes.string.isRequired,
            projectId: PropTypes.string.isRequired,
            activityId: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default WrappedComponentWithUpdatedPropNames;